import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import { t } from "i18next";

import { numberFormatter } from "../../helpers";
import EmployeeService from "../../services/employee";

import SortableHeader from "../../components/SortableHeader";
import NoRecords from "../../components/Table/NoRecords";

const WithdrawalChargesHeaderList = [
  {
    title: t("DATE"),
    style: { minWidth: "100px", width: "20%" },
  },
  {
    title: t("LOCATION.TITLE"),
    style: { minWidth: "150px", width: "20%" },
  },
  {
    title: t("MACHINE.NUMBER"),
    style: { minWidth: "150px", width: "20%", textAlign: "right" },
  },
  {
    title: t("BATCH_LABEL"),
    style: { minWidth: "100px", width: "20%", textAlign: "right" },
  },
  {
    title: t("DRAW_BEFORE_FILLING"),
    style: { minWidth: "150px", width: "20%", textAlign: "right" },
  },
  {
    title: t("CHARGE_TERMINAL.ADD_BILLS_LABEL"),
    style: { minWidth: "100px", width: "20%", textAlign: "right" },
  },
  {
    title: t("TOTAL"),
    style: { minWidth: "100px", width: "20%", textAlign: "right" },
  },
  {
    title: t("EMPLOYEE.EMP_BALANCE"),
    style: { minWidth: "150px", width: "20%", textAlign: "right" },
  },
  {
    title: t("EMPLOYEE.COUNTED"),
    style: { minWidth: "100px", width: "20%", textAlign: "center" },
  },
];

function WithdrawalCharges({ data, search }) {
  const [isLoading, setIsLoading] = useState(true);
  const [chargesList, setChargesList] = useState([]);

  useEffect(() => {
    setChargesList([]);
    getChargesDataFn(search);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  async function getChargesDataFn(search) {
    setIsLoading(true);

    const payload = {
      employeeId: data.employeeId,
      withdrawalId: data.withdrawId,
      search,
    };

    await EmployeeService.chargesList(payload)
      .then((response) => {
        const { dataList } = response.data;

        if (dataList && dataList.length) {
          dataList.forEach((item, index) => {
            // Save original numeric values BEFORE formatting
            item.addbillsOriginal = item.addbills;
            item.isNegativeAddBills = item.addbills < 0;
            
            if (index === 0) {
              item.empBal = dataList[index].amount - item.addbills;
            } else {
              item.empBal = dataList[index - 1].empBal - item.addbills;
            }

            item.drawBeforeFilling = numberFormatter(item.drawBeforeFilling);
            item.addbills = numberFormatter(item.addbills);
            item.total = numberFormatter(item.total);
            item.empBalFormatted = numberFormatter(item.empBal);
          });
        }

        setChargesList(dataList || []);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <React.Fragment>
      <Table striped bordered responsive size="sm">
        <thead>
          <tr>
            <SortableHeader
              headers={WithdrawalChargesHeaderList}
              isDisabled={true}
              showActionCol={false}
            />
          </tr>
        </thead>

        <tbody>
          {chargesList.length > 0 &&
            chargesList.map((item, l0Idx) => (
              <tr
                key={l0Idx}
                className={item.isNegativeAddBills ? 'table-danger' : ''}
                style={item.isNegativeAddBills ? { backgroundColor: '#EB3324', color: 'white' } : {}}
              >
                <td>{item.date}</td>
                <td>{item.locationName}</td>
                <td align="right">{item.terminalNumber}</td>
                <td align="right">{item.batch}</td>
                <td align="right">{item.drawBeforeFilling}</td>
                <td align="right">{item.addbills}</td>
                <td align="right">{item.total}</td>
                <td align="right">{item.empBalFormatted}</td>
                <td align="center">
                  {item.manuallyCounted ? (
                    <i className={`ri-check-fill ${item.isNegativeAddBills ? 'text-white' : 'text-success'}`}></i>
                  ) : (
                    <i className={`ri-close-fill ${item.isNegativeAddBills ? 'text-white' : 'text-danger'}`}></i>
                  )}
                </td>
              </tr>
            ))}

          {!isLoading && chargesList.length === 0 && (
            <NoRecords colSpan={WithdrawalChargesHeaderList.length + 1} />
          )}

          {isLoading && chargesList.length === 0 && (
            <NoRecords
              colSpan={WithdrawalChargesHeaderList.length + 1}
              msg={t("LOADING")}
            />
          )}
        </tbody>
      </Table>
    </React.Fragment>
  );
}

export default WithdrawalCharges;
